export const environment = {
    production: true,
    translationUrl: 'https://www.palsgaard.com/api/translations',
    authTTL: 14,
    concurrentFileDownload: 30,
};
